<template>
  <div class="vg-button-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "VgButtonGroup"
}
</script>

<style scoped>
.vg-button-group {
  /*box-sizing: border-box;*/
  width: 100%;
  padding-top: 10px;
  display: flex;
  align-items: center;
}

.vg-button-group.right {
  justify-content: flex-end;
}

.vg-button-group.top-border {
  border-top: solid 1px #E7E5E7;
  box-sizing: border-box;
  padding: 10px;
}

.vg-button-group .vg-button {
}

</style>